export const siteData = {
  businessName: "The Wedding Labs",
  tagline: "Your Love Story, Beautifully Designed",
  subtitle: "Premium wedding invitation websites that tell your unique story — starting at just ₹999",
  whatsappNumber: "919510756540",
  contactEmail: "hardik.songara.21549@gmail.com",

  navLinks: [
    { label: "Home", href: "#home" },
    { label: "Services", href: "#services" },
    { label: "WedSites", href: "#templates" },
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
  ],

  services: [
    {
      id: "template",
      title: "Template WedSite",
      price: "₹999",
      description: "Choose from our beautifully designed templates. Your wedding story, instantly ready to share.",
      features: [
        "Pre-designed premium templates",
        "Your names, dates & venue info",
        "Love story timeline",
        "Event schedule & details",
        "Photo gallery section",
        "RSVP via WhatsApp",
        "Mobile responsive design",
        "Ready in 24-48 hours",
      ],
      popular: true,
      ctaText: "Browse Templates",
      ctaAction: "#templates",
    },
    {
      id: "custom",
      title: "Custom WedSite",
      price: "Starts ₹2,499",
      description: "A completely bespoke wedding invitation website, designed from scratch to match your unique love story.",
      features: [
        "Fully custom design & layout",
        "Unique animations & interactions",
        "Custom color scheme & typography",
        "Unlimited sections & content",
        "Photo & video galleries",
        "RSVP with Google Sheets",
        "Custom domain support",
        "Priority support & revisions",
      ],
      popular: false,
      ctaText: "Get Custom Quote",
      ctaAction: "whatsapp",
    },
  ],

  howItWorks: [
    { step: 1, title: "Choose Your Style", description: "Browse our template collection or tell us your vision for a custom design.", icon: "Palette" },
    { step: 2, title: "Share Your Story", description: "Send us your photos, love story, event details, and venue information.", icon: "Heart" },
    { step: 3, title: "We Craft It", description: "Our team designs and builds your personalized wedding invitation website.", icon: "Sparkles" },
    { step: 4, title: "Share & Celebrate", description: "Get your unique link and share your beautiful WedSite with everyone.", icon: "Share2" },
  ],

  templates: [
    {
      id: 1,
      name: "Royal Indian",
      description: "Traditional elegance meets digital beauty. Perfect for grand Indian celebrations.",
      image: "/images/rajesh and lalita.png",
      price: "₹999",
      demoUrl: "https://rajesh-lalita.netlify.app/",
      features: ["Mandap animations", "Event timeline", "RSVP", "Gallery"],
      tag: "Popular",
    },
    {
      id: 2,
      name: "Modern Fun",
      description: "Modern UX fun cool site",
      image: "/images/chnadler&monica.png",
      price: "₹1,499",
      demoUrl: "https://monica-chandler.netlify.app/",
      features: ["Smooth scrolling", "Countdown timer", "RSVP", "Gallery"],
      tag: "New",
    },
    {
      id: 3,
      name: "Blossom Romance",
      description: "A dreamy floral paradise with delicate pink hues and elegant botanical touches. Perfect for romantic celebrations.",
      image: "/images/image.png",
      price: "₹1,499",
      demoUrl: "https://wedsitedemo4.netlify.app/",
      features: ["Floral animations", "Love story timeline", "RSVP", "Photo gallery"],
      tag: "Floral",
    },
  ],

  founder: {
    name: "Hardik Songara",
    role: "Founder & Developer",
    // image: "https://hardik21549.dev/ProfilePic%20(2).png",
    image: "/images/founder/Founder_Pic.png",
    bio: "Results-driven Software Engineer with hands-on experience in full-stack development (React, FastAPI, MongoDB). Passionate about crafting beautiful digital experiences that celebrate every couple's unique love story.",
    portfolio: "https://hardik21549.dev",
    social: {
      github: "https://github.com/Hardik74658",
      linkedin: "https://in.linkedin.com/in/hardik21549",
      twitter: "https://twitter.com/kano746581",
      instagram: "https://instagram.com/hardik_21549",
    },
  },

  testimonials: [
    {
      id: 1,
      name: "Priya & Arjun",
      role: "Married in Mumbai",
      content: "Our WedSite was absolutely stunning! Guests were so impressed, many thought we hired a top agency. Best investment ever!",
      image: "/images/testimonials/t1.jpg",
      rating: 5
    },
    {
      id: 2,
      name: "Sneha & Vikram",
      role: "Married in Jaipur",
      content: "The custom WedSite captured our love story perfectly. The animations and design were beyond our expectations.",
      image: "/images/testimonials/t2.jpg",
      rating: 5
    },
    {
      id: 3,
      name: "Meera & Rahul",
      role: "Married in Delhi",
      content: "Quick turnaround, beautiful design, and amazing customer service. Highly recommend The Wedding Labs!",
      image: "/images/testimonials/t3.jpg",
      rating: 5
    },
  ],

  stats: [
    { label: "WedSites Created", value: "50+" },
    { label: "Happy Couples", value: "50+" },
    { label: "Templates", value: "4+" },
    { label: "Starting Price", value: "₹999" },
  ],

  faqs: [
    { question: "What exactly is a WedSite?", answer: "A WedSite is a personalized wedding invitation website that includes your love story, event details, venue information, photo gallery, RSVP functionality, and more — all beautifully designed and shareable via a single link." },
    { question: "How long does it take to get my WedSite?", answer: "Template WedSites are typically ready within 24-48 hours after you share your details. Custom WedSites take 3-7 days depending on complexity." },
    { question: "Can I make changes after the WedSite is live?", answer: "Yes! Minor changes like date corrections or photo updates are included. For major redesigns, additional charges may apply." },
    { question: "How do guests RSVP?", answer: "Guests can RSVP directly through your WedSite. The responses are sent to you via WhatsApp or automatically added to a Google Sheet for easy tracking." },
    { question: "Is the WedSite mobile-friendly?", answer: "Absolutely! All our WedSites are fully responsive and look stunning on phones, tablets, and desktops." },
    { question: "How do I pay?", answer: "Payments are handled personally via WhatsApp. Once you choose a template or discuss your custom requirements, we'll share payment details directly." },
  ],
};

export const getWhatsAppUrl = (message, number) => {
  const num = number || siteData.whatsappNumber;
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
};
